import { keyValueList } from "../.fable/fable-library.3.2.6/MapUtil.js";

export function toProps(props) {
    return keyValueList(props, 1);
}

